import type { Pagination } from '@creator/sdk/modules/db/db.model';
import type { Wallet } from '@creator/sdk/modules/wallet/wallet.model';
import type { GetHoldersFilterBy, GetHoldersOrderBy } from '@creator/sdk/modules/wallet/wallet.service';
import creatorSdk from '@src/services/creator-sdk';
import type { QueryDocumentSnapshot } from 'firebase/firestore/lite';

export async function loadWallet(walletId: string): Promise<Wallet | null> {
    return creatorSdk.wallet.getWallet(walletId);
}

export async function loadWallets(
    lowerBound: QueryDocumentSnapshot<Wallet> | null,
    limit: number,
    filterBy: GetHoldersFilterBy[],
    orderBy: GetHoldersOrderBy[]
): Promise<Pagination<Wallet>> {
    return creatorSdk.wallet.getWallets(lowerBound, limit, filterBy, orderBy);
}
